export default {
  default: () => import("/codebuild/output/src4176857051/src/repo/layouts/default.vue").then(m => m.default || m),
  guest: () => import("/codebuild/output/src4176857051/src/repo/layouts/guest.vue").then(m => m.default || m),
  onboarding: () => import("/codebuild/output/src4176857051/src/repo/layouts/onboarding.vue").then(m => m.default || m)
}